/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A flexible carousel UI component for VDK Web. (@accedo/vdkweb-carousel) 6.0.4
* 
*******************************************************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import React from 'react';
import T from 'prop-types';
import CarouselComponent from '../components/CarouselComponent';
import CarouselLayoutManager from '../utils/CarouselLayoutManager';

/**
 * A carousel component based on a custom react-slick (https://github.com/Accedo-Global-Solutions/accedobuild-web/tree/f18af0dc20120012b5dfeeb040a15338d4870879/packages/vdkweb-react-slick/?at=feature%2FVDKWEB-412).
 *
 * * Custom styling
 * * Dots
 * * Arrows
 * * autoplay
 * * rtl
 * * variable width elements
 */
var Carousel = /*#__PURE__*/function (_React$Component) {
  _inherits(Carousel, _React$Component);
  var _super = _createSuper(Carousel);
  function Carousel(props) {
    var _this;
    _classCallCheck(this, Carousel);
    _this = _super.call(this, props);
    _this.layoutManager = new CarouselLayoutManager(props.options);
    return _this;
  }
  _createClass(Carousel, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(CarouselComponent, {
        displayObject: this.props.displayObject,
        items: this.props.items,
        keyProperty: this.props.keyProperty,
        onItemClick: this.props.onItemClick,
        options: this.layoutManager.getOptions(),
        responsiveSettings: this.layoutManager.getResponsiveSettings()
      });
    }
  }]);
  return Carousel;
}(React.Component);
Carousel.propTypes = {
  /** A React Component that will be used by the Carousel,
   * by using the React.cloneElement function,
   * to clone items for the carousel.
   */
  displayObject: T.element,
  /** List of items that will be used to populate the carousel. */
  items: T.array,
  /** The name of the field in an item to be used as unique identifier */
  keyProperty: T.string,
  /** Handler being triggered on item click event; receives the item object as payload */
  onItemClick: T.func,
  /** Extra options to render the carousel. check [@accedo/vdkweb-react-slick](https://github.com/Accedo-Global-Solutions/accedobuild-web/tree/f18af0dc20120012b5dfeeb040a15338d4870879/packages/vdkweb-react-slick/?at=feature%2FVDKWEB-412) documentation for more info */
  options: T.shape({
    afterChange: T.func,
    arrows: T.bool,
    autoplay: T.bool,
    autoplaySpeed: T.number,
    beforeChange: T.func,
    centerMode: T.bool,
    dots: T.bool,
    dotsClass: T.string,
    draggable: T.bool,
    focusOnSelect: T.bool,
    infinite: T.bool,
    itemHeight: T.oneOfType([T.number, T.string]),
    itemWidth: T.oneOfType([T.number, T.string]),
    nextArrow: T.element,
    pauseOnHover: T.bool,
    prevArrow: T.element,
    responsive: T.array,
    rtl: T.bool,
    slidesToScroll: T.number,
    slidesToShow: T.number,
    swipeToSlide: T.bool,
    useCSS: T.bool,
    variableWidth: T.bool
  })
};
export default Carousel;